"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEvent = void 0;
let events = {};
if ((window === null || window === void 0 ? void 0 : window.adobeDataLayer) && ((_a = window === null || window === void 0 ? void 0 : window.adobeDataLayer) === null || _a === void 0 ? void 0 : _a.length) > 0) {
    events = {
        event1: Promise.resolve().then(() => __importStar(require('./sass_events/event1'))),
        event2: Promise.resolve().then(() => __importStar(require('./sass_events/event2'))),
        event11: Promise.resolve().then(() => __importStar(require('./sass_events/event11'))),
        event12: Promise.resolve().then(() => __importStar(require('./sass_events/event12'))),
        event16: Promise.resolve().then(() => __importStar(require('./sass_events/event16'))),
        event24: Promise.resolve().then(() => __importStar(require('./sass_events/event24'))),
        event25: Promise.resolve().then(() => __importStar(require('./sass_events/event25'))),
        event26: Promise.resolve().then(() => __importStar(require('./sass_events/event26'))),
        event27: Promise.resolve().then(() => __importStar(require('./sass_events/event27'))),
        event29: Promise.resolve().then(() => __importStar(require('./sass_events/event29'))),
        event30: Promise.resolve().then(() => __importStar(require('./sass_events/event30'))),
        event32: Promise.resolve().then(() => __importStar(require('./sass_events/event32'))),
        event37: Promise.resolve().then(() => __importStar(require('./sass_events/event37'))),
        event38: Promise.resolve().then(() => __importStar(require('./sass_events/event38'))),
        event41: Promise.resolve().then(() => __importStar(require('./sass_events/event41'))),
        event42: Promise.resolve().then(() => __importStar(require('./sass_events/event42'))),
        event47: Promise.resolve().then(() => __importStar(require('./sass_events/event47'))),
        event53: Promise.resolve().then(() => __importStar(require('./sass_events/event53'))),
        event50: Promise.resolve().then(() => __importStar(require('./sass_events/event50'))),
        event57: Promise.resolve().then(() => __importStar(require('./sass_events/event57'))),
        event58: Promise.resolve().then(() => __importStar(require('./sass_events/event58'))),
        event62: Promise.resolve().then(() => __importStar(require('./sass_events/event62'))),
        event63: Promise.resolve().then(() => __importStar(require('./sass_events/event63'))),
        event89: Promise.resolve().then(() => __importStar(require('./sass_events/event89'))),
        eventVto: Promise.resolve().then(() => __importStar(require('./sass_events/eventVto'))),
    };
}
else if (window === null || window === void 0 ? void 0 : window.digitalData) {
    events = {
        event1: Promise.resolve().then(() => __importStar(require('./events/event1'))),
        event2: Promise.resolve().then(() => __importStar(require('./events/event2'))),
        event4: Promise.resolve().then(() => __importStar(require('./events/event4'))),
        event7: Promise.resolve().then(() => __importStar(require('./events/event7'))),
        event10: Promise.resolve().then(() => __importStar(require('./events/event10'))),
        event11: Promise.resolve().then(() => __importStar(require('./events/event11'))),
        event12: Promise.resolve().then(() => __importStar(require('./events/event12'))),
        event16: Promise.resolve().then(() => __importStar(require('./events/event16'))),
        event17: Promise.resolve().then(() => __importStar(require('./events/event17'))),
        event23: Promise.resolve().then(() => __importStar(require('./events/event23'))),
        event24: Promise.resolve().then(() => __importStar(require('./events/event24'))),
        event25: Promise.resolve().then(() => __importStar(require('./events/event25'))),
        event26: Promise.resolve().then(() => __importStar(require('./events/event26'))),
        event27: Promise.resolve().then(() => __importStar(require('./events/event27'))),
        event28: Promise.resolve().then(() => __importStar(require('./events/event28'))),
        event32: Promise.resolve().then(() => __importStar(require('./events/event32'))),
        event38: Promise.resolve().then(() => __importStar(require('./events/event38'))),
        event37: Promise.resolve().then(() => __importStar(require('./events/event37'))),
        event41: Promise.resolve().then(() => __importStar(require('./events/event41'))),
        event42: Promise.resolve().then(() => __importStar(require('./events/event42'))),
        event47: Promise.resolve().then(() => __importStar(require('./events/event47'))),
        event50: Promise.resolve().then(() => __importStar(require('./events/event50'))),
        event52: Promise.resolve().then(() => __importStar(require('./events/event52'))),
        event53: Promise.resolve().then(() => __importStar(require('./events/event53'))),
        event54: Promise.resolve().then(() => __importStar(require('./events/event54'))),
        event57: Promise.resolve().then(() => __importStar(require('./events/event57'))),
        event58: Promise.resolve().then(() => __importStar(require('./events/event58'))),
        event62: Promise.resolve().then(() => __importStar(require('./events/event62'))),
        event63: Promise.resolve().then(() => __importStar(require('./events/event63'))),
        event79: Promise.resolve().then(() => __importStar(require('./events/event79'))),
        event90: Promise.resolve().then(() => __importStar(require('./events/event90'))),
        event92: Promise.resolve().then(() => __importStar(require('./events/event92'))),
        event94: Promise.resolve().then(() => __importStar(require('./events/event94'))),
        scAdd: Promise.resolve().then(() => __importStar(require('./events/scAdd'))),
        eventVto: Promise.resolve().then(() => __importStar(require('./events/eventVto'))),
    };
}
const registerEvent = (fname, event) => __awaiter(void 0, void 0, void 0, function* () {
    if (fname) {
        try {
            const fun = yield events[fname];
            fun === null || fun === void 0 ? void 0 : fun.launchEvent(event);
        }
        catch (error) {
            throw new Error(error);
        }
    }
});
exports.registerEvent = registerEvent;
